import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form, Field } from 'formik';

import TextInput from '../common/form/TextInput';
import pageWrapper from '../containers/MainPage';
import Button from '../common/Button';
import FormFeedback from '../common/form/FormFeedback';
import UpdateUser, { validationSchema } from '../../models/UpdateUser';
import { updateUser } from '../../redux/ducks/auth';
import FormResult from '../../FormResult';
import AvatarField from '../common/AvatarField';

class AccountPage extends Component {
  static renderForm(formProps) {
    const {
      // values,
      // errors,
      // touched,
      // handleChange,
      // handleBlur,
      status,
      handleSubmit,
      isSubmitting,
    } = formProps;

    const uploadCallback = (result) => {
      formProps.setFieldValue('tempAvatarUploadName', result);
      formProps.handleSubmit();
    };

    return (
      <Form>
        <FormFeedback status={status} />

        <div className="columns">
          <div className="column">
            <Field
              name="firstName"
              label="First Name"
              autoComplete="given-name"
              component={TextInput}
            />
          </div>
          <div className="column">
            <Field
              name="lastName"
              label="Last Name"
              autoComplete="family-name"
              component={TextInput}
            />
          </div>
        </div>

        <div className="columns">
          <div className="column is-half">
            <Field
              name="email"
              label="Email"
              type="email"
              autoComplete="email"
              component={TextInput}
            />
          </div>

          <div className="column is-half">
            <AvatarField onSuccess={uploadCallback} />
          </div>
        </div>

        <hr />

        <p className="content">
          If you&apos;d like to change your password, enter and confirm a new one below. Leave blank
          if you don&apos;t want to make any changes.
        </p>

        <div className="columns">
          <div className="column is-half">
            <Field
              name="newPassword"
              label="Change Password"
              type="password"
              component={TextInput}
            />
            <Field
              name="confirmPassword"
              label="Confirm Password"
              type="password"
              component={TextInput}
            />
          </div>
        </div>

        <div className="has-text-right">
          <Button
            type="submit"
            label="Save Changes"
            isActive={isSubmitting}
            isDisabled={isSubmitting}
            color="primary"
            handler={handleSubmit}
            className="accountForm-submitButton"
          />
        </div>
      </Form>
    );
  }

  render() {
    const { user, onSubmit } = this.props;

    return (
      <div className="accountForm columns is-centered">
        <div className="column is-two-thirds">
          <h2 className="title is-3">Update your account</h2>

          <Formik
            initialValues={user}
            enableReinitialize
            onSubmit={(values, { setSubmitting, setStatus, resetForm }) => {
              const onSuccess = (newUser) => {
                setSubmitting(false);
                resetForm(new UpdateUser(newUser));
                setStatus(new FormResult(200, 'Account updated successfully.'));
              };
              const onFailure = (status) => {
                setSubmitting(false);
                setStatus(new FormResult(status));
              };

              onSubmit(values, onSuccess, onFailure);
            }}
            validationSchema={validationSchema}
            render={AccountPage.renderForm}
          />
        </div>
      </div>
    );
  }
}

AccountPage.propTypes = {
  user: PropTypes.instanceOf(UpdateUser).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const {
    auth: { user },
  } = state;

  return {
    user: new UpdateUser(user),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: (user, onSuccess, onFailure) => {
      dispatch(updateUser(user, onSuccess, onFailure));
    },
  };
}

export default pageWrapper(
  connect(mapStateToProps, mapDispatchToProps)(AccountPage),
  'Account Settings'
);



// WEBPACK FOOTER //
// ./src/components/pages/AccountPage.jsx